export default "__VITE_ASSET__BOWA_34s__"